import { forwardRef } from 'react';

import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

const Transition = forwardRef(function Transition(
	props: TransitionProps & {
		children: React.ReactElement<unknown, string | React.JSXElementConstructor<unknown>>;
	},
	ref: React.Ref<unknown>
) {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // Check if the screen size is mobile
	return <Slide direction={isMobile ? 'up' : 'right'} timeout={1000} ref={ref} {...props} />;
});

export default Transition;
